import * as dealInfoHelpers from '@wix/wix-vod-shared/src/common/utils/deal-info-helpers';
import sharedTranslations from 'messages/shared';
import formatMessageWithPrice from 'shared/utils/format-message-with-price';
import { isSubscriptionEnabled, isSubscribedTo } from '@wix/wix-vod-shared/src/common/ui-selectors/channel/pricing';


/**
 * Is video subscribe button visible
 * @param props {Object}
 * @param props.channel {Object}
 * @return {Boolean}
 */
export function isVisible({ channel = {} }) {
  return isSubscriptionEnabled(channel) && !isSubscribedTo(channel);
}

/**
 * Video sign in to play button text
 * @param props {Object}
 * @param props.channel {Object}
 * @param props.translation {Object} default is sharedTranslations.getSubscription
 * @return {React.Component}
 */
export default function renderSubscribeButtonText(props) {
  if (!isVisible(props)) {
    return null;
  }

  return formatMessageWithPrice(
    props.translation || sharedTranslations.getSubscription,
    dealInfoHelpers.getSubscriptionPriceInfo(props.channel.dealInfo)
  );
}



// WEBPACK FOOTER //
// ./src/widget/components/overlay-texts/channel/subscribe-button-text.js